import { render } from "./show_product.vue?vue&type=template&id=9ee123b4"
import script from "./show_product.vue?vue&type=script&lang=js"
export * from "./show_product.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__